import baseApi from "./baseApi"

export default  {
    async getHolidays(params) {

        let queryString = Object.keys(params)
            .filter(function(key) {
                if (key === "selectedDate" || key === "selectedPlantId") {
                    // this seems to be something that should have been removed from the vuetify table component - either way we don't need it here
                    return true;
                }
                return false;
            })
            .map(function(key) {
                return key + "=" + encodeURIComponent(params[key]);
            }).join("&");

        let request = await baseApi.createHttpRequest();
        let location = "/holidays/all?" + queryString

        let result = await request.get(location);
        
        return result.data.map(h => ({
            Date: h.Date.substring(0,10),
            HolidayName: h.HolidayName,
            ID: h.ID,
            Regions: h.Regions
        }));
    },
    async addUpdateHoliday(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/holidays/edit", item);
        return result.data;
    }
}